"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var SizeConverter =
/** @class */
function () {
  function SizeConverter() {}

  SizeConverter.prototype.fromMessage = function (message) {
    return {
      height: utils_1.withDefault(message.height, 0),
      width: utils_1.withDefault(message.width, 0)
    };
  };

  SizeConverter.prototype.toMessage = function (object) {
    return {
      height: object.height,
      width: object.width
    };
  };

  return SizeConverter;
}();

exports.SizeConverter = SizeConverter;
exports.sizeConverter = new SizeConverter();